// extracted by css-extract-rspack-plugin
export default {"pill":"uQbAz","field":"kx5Qj"};